import useAPI from '@/hooks/useAPI';
import InsuranceRepository from '@/repositories/InsuranceRepository';

const useInsurancePlans = (enabled = true) => {
  const insuranceRepository = InsuranceRepository();

  return useAPI({
    queryKey: ['getInsurancePlans'],
    queryFn: async () => {
      return await insuranceRepository.getPlans();
    },
    enabled
  });
};

export default useInsurancePlans;
